// extracted by mini-css-extract-plugin
module.exports = {"navigateBtnCol":"specialNoteDetails_navigateBtnCol__R2I7a","dividerLine":"specialNoteDetails_dividerLine__2zDLJ"};